import {AppModel} from 'app/client/models/AppModel';
import {DomElementArg} from 'grainjs';

export function buildUserMenuBillingItem(
  _appModel: AppModel,
  ..._args: DomElementArg[]
) {
  return null;
}

export function buildAppMenuBillingItem(
  _appModel: AppModel,
  ..._args: DomElementArg[]
) {
  return null;
}
